export const isBrowser =
  typeof window !== 'undefined' && typeof document !== 'undefined';

export const ready = (callback) => {
  if (!isBrowser) {
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
    return;
  }

  callback();
};

export const prefersReducedMotion = () => {
  if (!isBrowser || typeof window.matchMedia !== 'function') {
    return false;
  }

  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

export const readPxValue = (element, customProperty, fallback) => {
  const rawValue = getComputedStyle(element).getPropertyValue(customProperty).trim();

  if (!rawValue) {
    return fallback;
  }

  if (rawValue.endsWith('rem')) {
    return (
      parseFloat(rawValue) *
      parseFloat(getComputedStyle(document.documentElement).fontSize)
    );
  }

  if (rawValue.endsWith('em')) {
    return parseFloat(rawValue) * parseFloat(getComputedStyle(element).fontSize);
  }

  if (rawValue.endsWith('px')) {
    return parseFloat(rawValue);
  }

  return Number.parseFloat(rawValue) || fallback;
};
